<template>
  <div>
    <prohead></prohead>
    <div class="banner" style="background: url('../../static/img/k_bg.jpg')">
      新闻资讯
    </div>
    <div class="banner_kai">

      <div class="banner_new" style="padding-top: 40px;padding-bottom: 40px">
        <div style="height: 50px;cursor: pointer" @click="fanhui()">
          <img src="../../static/img/返回.png" alt="" style="display: block;float: left">
          <div style="float:left;line-height: 25px;margin-left: 5px;">
            返回列表
          </div>
        </div>
            <div style="font-size: 24px;
font-family: PingFang;
font-weight: bold;
color: #000000;
text-align: center;
line-height: 30px;">
              {{detailsdata.title}}
            </div>
            <p style="font-size: 16px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #999999;

line-height: 60px;text-align: center">{{detailsdata.create_time}}</p>
            <div v-html="detailsdata.content">
              {{detailsdata.content}}
            </div>
      </div>
    </div>
    <Profooter></Profooter>
  </div>

</template>

<script>
import Prohead from '../components/Prohead'
import Profooter from "../components/Profooter";
export default {
  name: "index",
  components: {Prohead,Profooter},
  data() {
    return {
      data:[],
      detailsdata:'',
      url:'http://child.yohann.cn/'
    }
  },
  created() {

    this.details()
  },
  mounted() {


  },
  methods: {
    fanhui(){
      this.$router.push('/newadd?page='+this.$route.query.page)
    },
    details(){
      console.log(this.$route.query.id)
      let formdata = new FormData()
      formdata.append('id',this.$route.query.id)
      this.$axios.post('/index/Article/articleDetail',formdata).then(res => {
          this.detailsdata= res.data.data
      });
    },
  }
}
</script>

<style scoped>
.depict{
  height:46px ;
  width: 900px;
  margin-top: 10px;
  font-size: 16px;

}
.new-title .time{
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 30px;
  margin-top: 10px;
  display: block;
  width: 900px;
  height: 30px;

}

.new_img{
  width: 280px;
  height: 160px;
  border-radius: 10px;
  margin-right: 30px;
}
.new_img img{
  width: 280px;
  height: 160px;
  border-radius: 10px;
}
.banner_new li{
  width: 1300px;
  height: 220px;
}
.banner_new li div{
  float: left;
}
.banner_pin div{
  float: left;
}
.box3{
  margin: 0 auto;
  width: 1920px;
  height: 618px;
  //background: url("../../static/img/bg2.jpg");
}
.box_banner2{
  width: 1300px;
  margin: 0 auto;
  height: 620px;
  text-align: center;
}
.box_imgbanner div{
  float: left;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 36px;
  text-align: left;
}
.box_imgbanner{
  margin-top: 60px;
}
.banner_pintext{
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.titlebox{
  text-align: center;
  font-size: 40px;
  font-weight: 500;
}
.title_fu{
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  text-align: center;
}
.banner{
  height: 300px;
  font-size: 40px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 300px;
  text-align: center;
}
.banner_kai{
  width: 1300px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/newdetails.vue